export default __webpack_public_path__ + "static/anilPokhriyal2-f7061ce995010d2a32d135bf98d4e3aa.jpg";